module.exports = __webpack_public_path__ + "static/Word-62659577f70e63082e66e5ee03f0bd38.svg";